<template>
  <div>
      <!-- 详情的对话框 -->
      <el-dialog
        title="详情"
        :visible.sync="dialog.visible"
        append-to-body
        :modal-append-to-body="false"
        @closed="closed"
        :close-on-click-modal="true"
        width="60%"
      >
        <div>
          <div class="plugin-manage-top">
            <div class="left">
              <span class="ellipsis">
                <p>插件名称：</p>
                {{ pluginGroupData.name }}
              </span>
              <span class="ellipsis">
                <p>插件渠道：</p>
                {{ pluginGroupData.channel }}
              </span>
            </div>
            <div class="right">
              <el-button
                v-auth="'pluginManagePluginManageUpload'"
                type="primary"
                size="small"
                @click="handleAdd(pluginGroupData.pluginGroupId)"
                >上传插件</el-button
              >
            </div>
          </div>
          <div class="plugin-manage-search">
            <div>
              <el-input
                clearable
                size="small"
                v-model="searchParams.search"
                placeholder="版本号"
                style="width: 150px"
              ></el-input>
              <el-select
                clearable
                v-model="searchParams.status"
                size="small"
                placeholder="状态"
                style="margin-left: 15px; width: 150px"
              >
                <el-option label="上线" value="1"></el-option>
                <el-option label="下线" value="0"></el-option>
              </el-select>
            </div>
            <div>
              <el-button
                v-auth="'pluginManagePluginManageSearch'"
                type="primary"
                size="small"
                @click="search"
                >搜索</el-button
              >
            </div>
          </div>
          <!-- 列表 -->
          <el-table :data="list" border stripe>
            <el-table-column label="版本" prop="ver"></el-table-column>
            <el-table-column
              label="发布时间"
              prop="createTime"
            ></el-table-column>
            <el-table-column label="最小支持版本" prop="minHostVer">
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status === 0"
                  type="text"
                  size="small"
                  v-auth="'pluginManagePluginManageOnline'"
                  @click="handleChangeStatus(scope.row, '1')"
                  >上线</el-button
                >
                <el-button
                  v-if="scope.row.status === 1"
                  type="text"
                  size="small"
                  v-auth="'pluginManagePluginManageOffline'"
                  @click="handleChangeStatus(scope.row, '0')"
                  >下线</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-auth="'pluginManagePluginManageEdit'"
                  @click="handleEdit(scope.row, pluginGroupData.pluginGroupId)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-auth="'pluginManagePluginManageDel'"
                  @click="handleDel(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <ElementPagination
            style="margin-bottom: 20px"
            :current-page="searchParams.current"
            :page-size="searchParams.size"
            :total="searchParams.total"
            :page-sizes="[10, 20, 30, 40, 50]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>

        <!-- 保存-取消 -->
        <span slot="footer" style="flex-end">
          <el-button size="small" @click="hide">取 消</el-button>
          <el-button size="small" type="primary" @click="confirm()"
            >保 存</el-button
          >
        </span>
        <UpLoadDialog ref="uploadPlugin" @reload="getList()"></UpLoadDialog>
      </el-dialog>
  </div>
</template>

<script>
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import UpLoadDialog from "./uploadPlugin.vue";
import {
  getPluginsList,
  deletePlugins,
  putOnPlugins,
  takeOffPlugins,
} from "@/api/pluginManage/index";
export default {
  name: "WebSaaSDetailDialog",
  components: {
    UpLoadDialog,
    ElementPagination,
  },
  data() {
    return {
      /** 插件组数据 */
      pluginGroupData: {
        pluginGroupId: "",
        channel: "",
        name: "",
      },
      /** 分页数据 */
      searchParams: {
        current: 1,
        size: 10,
        total: 0,
        pluginGroupId: "",
        /** 模糊搜索：[插件版本] */
        search: "",
        /** 状态：0下线 1上线 */
        status: "",
      },
      dialog: {
        visible: false,
        title: "",
        disabled: false,
      },
      list: [
        {
          id: "1",
          name: "插件名称",
          status: "渠道",
          descr: "最新版本",
        },
      ],
    };
  },
  methods: {
    /** 确认 */
    confirm() {
      this.hide();
    },
    /** 删除插件 */
    handleDel(id) {
      console.log("删除插件", id);
      this.$confirm("此操作将永久删除该插件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await deletePlugins(id);
          console.log("删除插件的响应", data);
          if (data.code === 200) {
            Message.success("删除成功");
            this.getList();
          }
        })
        .catch(() => {
          Message.info("已取消删除");
        });
    },
    /** 上线插件 */
    handleChangeStatus(row, status) {
      console.log("上/下线插件", row);
      this.$confirm(
        `此操作将${status === "1" ? "上" : "下"}线该插件, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          this.changeStatus(row, status);
        })
        .catch(() => {
          Message.info("已取消上/下线");
        });
    },
    /** 修改上下线 */
    async changeStatus(row, status) {
      if (status === "1") {
        const { data } = await putOnPlugins(row.id);
        console.log("上线插件的响应", data);
        if (data.code === 200) {
          Message.success("上线成功");
          this.getList();
        }
      } else {
        const { data } = await takeOffPlugins(row.id);
        console.log("下线插件的响应", data);
        if (data.code === 200) {
          Message.success("下线成功");
          this.getList();
        }
      }
    },
    /** 编辑某一个插件 */
    handleEdit(row, pluginGroupId) {
      console.log("编辑某一个插件", row);
      this.$refs.uploadPlugin.show(row, pluginGroupId);
    },
    /** 上传插件 */
    handleAdd(pluginGroupId) {
      this.$refs.uploadPlugin.show(undefined, pluginGroupId);
    },
    async show(row) {
      console.log("拿到的row", row);
      if (row.channelId !== 0) {
        this.pluginGroupData.channel =
          `(${row.channelId})` + " " + row.channelName;
      } else {
        this.pluginGroupData.channel = "所有渠道";
      }
      this.pluginGroupData.name = row.name;
      this.searchParams.pluginGroupId = row.id;
      this.pluginGroupData.pluginGroupId = row.id;
      await this.getList();
      this.dialog.visible = true;
    },
    hide() {
      this.dialog.visible = false;
      this.$emit("reload");
    },
    closed() {
      console.log("closed");
      /** 清理表单数据 */

      if (this.$refs.form) {
        this.form = {
          id: "",
          name: "",
          goods: "",
          time: "",
          period: "",
          price: "",
          show: "",
          status: "",
          remark: "",
        };
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }

      console.log("form", this.$refs.form);
    },
    //^ ^--------------分页相关 start-------------^ ^
    /** 获取分页列表 */
    async getList() {
      const { data } = await getPluginsList(this.searchParams);
      console.log("获取分页数据的响应", data);
      this.searchParams.total = data.data.total;
      /** 赋值 */
      this.list = data.data.records;
    },
    /** 搜索事件 */
    search() {
      this.searchParams.current = 1;
      this.getList();
      /** 提示用户 */
      Message.success("搜索成功");
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.plugin-manage-top {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 250px !important;
    }
    p {
      display: inline-flex;
      width: 70px;
      font-size: 16px;
      font-weight: 500;
    }
  }
}
.plugin-manage-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>